export default __webpack_public_path__ + "static/media/button_login.e3e11171.svg";